import { CommonModule } from '@angular/common';
import { ProgressBar as ProgressBarBase } from 'prime-ng-old/progressbar';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = (a0, a1) => ({
  "p-progressbar p-component": true,
  "p-progressbar-determinate": a0,
  "p-progressbar-indeterminate": a1
});
const _c1 = a0 => ({
  $implicit: a0
});
function UiProgressBarComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("display", ctx_r0.value != null && ctx_r0.value !== 0 ? "flex" : "none");
    i0.ɵɵattribute("data-pc-section", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.value, "", ctx_r0.unit);
  }
}
function UiProgressBarComponent_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiProgressBarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵconditionalCreate(2, UiProgressBarComponent_Conditional_1_Conditional_2_Template, 2, 5, "div", 5);
    i0.ɵɵtemplate(3, UiProgressBarComponent_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r0.value + "%")("background", ctx_r0.color);
    i0.ɵɵattribute("data-pc-section", "value");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showValue && !ctx_r0.contentTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c1, ctx_r0.value));
  }
}
function UiProgressBarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "container");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background", ctx_r0.color);
    i0.ɵɵattribute("data-pc-section", "value");
  }
}
export let UiProgressBarComponent = /*#__PURE__*/(() => {
  class UiProgressBarComponent extends ProgressBarBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiProgressBarComponent_BaseFactory;
        return function UiProgressBarComponent_Factory(__ngFactoryType__) {
          return (ɵUiProgressBarComponent_BaseFactory || (ɵUiProgressBarComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiProgressBarComponent)))(__ngFactoryType__ || UiProgressBarComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiProgressBarComponent,
        selectors: [["ui-progressBar"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 14,
        consts: [["role", "progressbar", 3, "ngStyle", "ngClass"], [1, "p-progressbar-value", "p-progressbar-value-animate", 2, "display", "flex", 3, "width", "background"], [1, "p-progressbar-indeterminate-container"], [1, "p-progressbar-value", "p-progressbar-value-animate", 2, "display", "flex"], [1, "p-progressbar-label"], [3, "display"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-progressbar-value", "p-progressbar-value-animate"]],
        template: function UiProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵconditionalCreate(1, UiProgressBarComponent_Conditional_1_Template, 4, 10, "div", 1);
            i0.ɵɵconditionalCreate(2, UiProgressBarComponent_Conditional_2_Template, 2, 4, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction2(11, _c0, ctx.mode === "determinate", ctx.mode === "indeterminate"));
            i0.ɵɵattribute("aria-valuemin", 0)("aria-valuenow", ctx.value)("aria-valuemax", 100)("data-pc-name", "progressbar")("data-pc-section", "root");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.mode === "determinate" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.mode === "indeterminate" ? 2 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle],
        styles: ["@layer primeng{.p-progressbar[_ngcontent-%COMP%]{position:relative;overflow:hidden}.p-progressbar-determinate[_ngcontent-%COMP%]   .p-progressbar-value[_ngcontent-%COMP%]{height:100%;width:0%;position:absolute;display:none;border:0 none;display:flex;align-items:center;justify-content:center;overflow:hidden}.p-progressbar-determinate[_ngcontent-%COMP%]   .p-progressbar-label[_ngcontent-%COMP%]{display:inline-flex}.p-progressbar-determinate[_ngcontent-%COMP%]   .p-progressbar-value-animate[_ngcontent-%COMP%]{transition:width 1s ease-in-out}.p-progressbar-indeterminate[_ngcontent-%COMP%]   .p-progressbar-value[_ngcontent-%COMP%]:before{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;animation:_ngcontent-%COMP%_p-progressbar-indeterminate-anim 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.p-progressbar-indeterminate[_ngcontent-%COMP%]   .p-progressbar-value[_ngcontent-%COMP%]:after{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;animation:_ngcontent-%COMP%_p-progressbar-indeterminate-anim-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.15s}}@keyframes _ngcontent-%COMP%_p-progressbar-indeterminate-anim{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes _ngcontent-%COMP%_p-progressbar-indeterminate-anim-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}[_nghost-%COMP%]{display:block;margin:20px 0}.p-progressbar[_ngcontent-%COMP%]{border:0 none;border-color:var(--progressBarBorderColor);min-height:6px;height:auto;min-width:240px;background-color:var(--progressBarBgColor)}.p-progressbar[_ngcontent-%COMP%]   .p-progressbar-value[_ngcontent-%COMP%]{border:0 none;margin:0;background:var(--progressBarValueBgColor);transition:width .2s!important}.p-progressbar[_ngcontent-%COMP%]   .p-progressbar-label[_ngcontent-%COMP%]{margin-top:0;color:var(--textColor);display:none!important;height:24px}"],
        changeDetection: 0
      });
    }
  }
  return UiProgressBarComponent;
})();